<template>
  <v-container fluid grid-list-xs>
    <v-layout row wrap fill-height>
      <v-flex xs12>
        <v-card flat>
          <v-card-title class="headline justify-center">
            <image-icon :image="image" :row-type="rowType" avatar :class="imageWidthClass"></image-icon>
            &emsp;<span>{{ displayName }}</span>
          </v-card-title>
        </v-card>
      </v-flex>

      <v-flex xs12>
        <v-card flat v-if="authArrived || isLoading">
          <v-card-title>
            <span class="subheading">
              <logo small></logo>
              <span v-if="!updateProfile" class="subtitle-1">
                Update your user profile
              </span>
            </span>
            <v-spacer></v-spacer>
            <fid-chip v-if="itemReason" :item-reason="userReason" clickit="userchipped" @userchipped="updateProfile = !updateProfile"></fid-chip>

            <v-tooltip
              left
              color="secondary" 
              content-class="caption"
              :close-delay="tooltips.closeDelay"
              :open-on-hover="true"
              :transition="tooltips.transition">
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" @click="updateProfile = !updateProfile">
                  <v-icon>{{ !updateProfile ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
                </v-btn>
              </template>
              <span>Update profile</span>
            </v-tooltip>

          </v-card-title>
          <v-card-text v-if="updateProfile">
            <v-form ref="userprofileupdate"  v-model="valid">
              <v-flex xs12>
                <v-text-field
                  clearable
                  autofocus
                  autocomplete="new-password"
                  v-model="Profile.personalAssistantInformation"
                  :label="unCamel('personalAssistantInformation')"
                  :rules="[getMaxLengthRule(100)]"
                  :counter="100"
                ></v-text-field>
                <v-layout row>
                  <v-flex xs8>
                    <v-text-field
                      clearable
                      autofocus
                      autocomplete="new-password"
                      v-model="Profile.contactEmail"
                      :label="unCamel('contactEmail')"
                      :rules="getEmailRules().concat([getMaxLengthRule(50)])"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 class="justify-right">
                    <v-checkbox
                      autofocus
                      v-model="Profile.contactEmailPrivate"
                      label="Private"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
                <v-text-field v-if="!enableCompanySearch"
                  full-width
                  autofocus
                  autocomplete="new-password"
                  :value="profileAllCompanyNames"
                  :label="unCamel('currentCompany')"
                  disabled
                >
                  <v-icon v-if="!enableCompanySearch" class="fid-icon-slot" slot="append" @click="enableCompanySearch=true">edit</v-icon>
                  <v-icon v-if="profileCompany" class="fid-icon-slot" slot="append-outer" @click="deleteCompany">delete</v-icon>
                </v-text-field>
                <v-autocomplete v-if="enableCompanySearch"
                  full-width
                  autofocus
                  autocomplete="new-password"
                  ref="companySearch"
                  v-model="companySearchModel"
                  :items="companyNameItems"
                  item-value="companyID"
                  item-text="name"
                  :loading="isLoading"
                  :search-input.sync="companySearch"
                  hide-no-data
                  hide-selected
                  label="Find your company in our list"
                  placeholder="Start typing company name"
                  return-object
                  dense
                  cache-items
                  open-on-clear
                >
                  <v-icon v-if="companySearchModel && companySearchModel.companyID !== Profile.companyID" class="fid-icon-slot" slot="append" @click="companySearchChanged">check_circle</v-icon>
                  <v-icon class="fid-icon-slot" slot="append-outer" @click="enableCompanySearch=false">cancel</v-icon>
                  <v-icon class="fid-icon-slot" slot="prepend-inner" :color="getIconColor('company')">{{ getIcon('company') }}</v-icon>
                </v-autocomplete>
              </v-flex>
            </v-form>
          </v-card-text>
          <v-card-actions v-if="updateProfile">
            <v-spacer></v-spacer>
            <v-btn :disabled="!valid || !changed" color="primary" @click="save">Save</v-btn>
            <v-btn :disabled="!changed" color="error" @click="resetProfile">Reset</v-btn>
            <v-btn color="secondary" @click="cancel">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>



      <v-flex xs12 sm12 md12 lg6 xl6 fill-height>
        <v-card v-if="vimeoConnected" flat>
          <v-card-title class="mb-0 pb-0">
            <span class="subtitle-1">
              <logo name="vimeo" small></logo>
              <span v-if="!showVimeo">
                See
              </span>
              <span>
                Vimeo persona
              </span>
            </span>
            <v-spacer></v-spacer>
            <v-btn color="secondary"
              @click.stop="disconnectVimeo"
              icon
              :disabled="disconnecting || connecting"
            >
              <v-icon :color="getIconColor('logout')">
                {{ getIcon('logout') }}
              </v-icon>
            </v-btn>
            <fid-chip v-if="vimeoUserItemReason" 
              :item-reason="vimeoUserItemReason" 
              clickit="chipped" 
              @chipped="showVimeo = !showVimeo"
            ></fid-chip>
            <v-tooltip
              left
              color="secondary" 
              content-class="caption" 
              :close-delay="tooltips.closeDelay"
              :open-on-hover="true"
              :transition="tooltips.transition">
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon @click="flipShowVimeo">
                  <v-icon v-if="vimeoUserItem">{{ !showVimeo ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
                </v-btn>
              </template>
              <span>Vimeo persona</span>
            </v-tooltip>

          </v-card-title>
          <v-card-text>
            <vimeo-content v-if="showVimeo && vimeoUserItem"
              :vimeo-user-item="vimeoUserItem"
              :user-id="userID"
            ></vimeo-content>
          </v-card-text>
        </v-card>

        <v-card v-else-if="userProfileID" flat>
          <v-card-title>
            <span class="subtitle-1">
              <logo name="vimeo" small></logo>
              <span class="ml-1">
                <span v-if="vimeoID">Rec</span><span v-else>C</span>onnect Vimeo persona
              </span>
            </span>
            <v-spacer></v-spacer>
            <v-btn color="primary" :disabled="skipEndpoint || connecting" small  @click="vimeoOauthRedirect">Connect</v-btn>
          </v-card-title>
        </v-card>

        <v-card v-else flat>
          <v-card-title class="subheading justify-center">{{ checkingIdentity }}</v-card-title>
        </v-card>
     </v-flex>
      <v-flex xs12 sm12 md12 lg6 xl6>
        <v-card v-if="personItem" flat>
          <v-card-title class="mb-0 pb-0">
            <span class="subtitle-1">
              <logo small></logo>
              <span v-if="!showPersona">
                See
              </span>
              <span>
                FilmID persona
              </span>
            </span>
            <v-spacer></v-spacer>
            <fid-chip v-if="itemReason" :item-reason="itemReason" clickit="personchipped"
              @personchipped="showPersona = !showPersona"></fid-chip>
      
            <v-tooltip left color="secondary" content-class="caption" :close-delay="tooltips.closeDelay" :open-on-hover="true"
              :transition="tooltips.transition">
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon @click="flipShowPersona">
                  <v-icon>{{ !showPersona ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
                </v-btn>
              </template>
              <span>FilmID persona</span>
            </v-tooltip>
      
          </v-card-title>
          <v-card-text>
            <big-content v-if="showPersona" :row-types="rowTypes" :item="personItem"></big-content>
          </v-card-text>
        </v-card>
      
        <v-card flat v-else>
          <v-card-title v-if="!isLoading" class="mb-0 pb-0" flat>
            You don't yet have a FilmID persona - yet to be implemented
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import Logo from '@/components/Logo'
import { SearchUtils } from '@/js'
import { mutate, showToaster, mergeControls } from '@/js/apollo'
import {
  RemoveVimeoConnection,
  Controls,
  VimeoOauthEndpoint,
  ProviderAuth,
  UserProfile,
  UserContacts,
  ViewCompanyNameAutocompletes,
  updateUserProfile,
  PersonPage,
  VimeoUserInfo
} from '@/gql'
import { getIcon, getIconColor, settings } from '@/js/store'
import Imageicon from '@/components/Imageicon'
import Vimeocontent from '@/components/Vimeocontent'
import Bigcontent from '@/components/Bigcontent'
import Fidchip from '@/components/Fidchip'
import ifvisible from 'ifvisible.js'
export default {
  components: {
    'image-icon': Imageicon,
    'vimeo-content': Vimeocontent,
    'fid-chip': Fidchip,
    'logo': Logo,
    'big-content': Bigcontent
  },
  computed: {
    tooltips () {
      return settings.tooltips
    },
    checkingIdentity () {
      return this.isLoading ? this.checkFid : this.checkOut
    },
    showVimeo: {
      get () {
        return this.Controls && this.Controls.showVimeo
      },
      set (value) {
        mergeControls({
          showVimeo: value
        })
      }
    },
    showPersona: {
      get () {
        return this.Controls && this.Controls.showPersona
      },
      set (value) {
        mergeControls({
          showPersona: value
        })
      }
    },
    userReason () {
      return {
        matchType: 'user',
        ProviderAuth: this.ProviderAuth
      }
    },
    authReady () {
      return this.ProviderAuth && this.ProviderAuth.ready
    },
    skipEndpoint () {
      return !this.authReady || !this.userProfileID
    },
    authEndpoint () {
      return this.VimeoOauthEndpoint && this.VimeoOauthEndpoint.url
    },
    itemReason () {
      return this.personItem && this.personItem.itemReason
    },
    vimeoUserItem () {
      return this.VimeoUserInfo && SearchUtils.makeSearcherFromVimeoUser(this.VimeoUserInfo)
    },
    vimeoUserItemReason () {
      return this.vimeoUserItem && this.vimeoUserItem.itemReason
    },
    profilePerson () {
      return this.Profile && this.Profile.Person
    },
    profilePersonID () {
      return (this.Profile && this.Profile.personID)
      // we're going to pass on this for now as Usercontacts can return multiple people
      // TODO the workflow for attaching a user to his filmID persona
      // (this.UserContacts && this.UserContacts[0] && this.UserContacts && this.UserContacts[0].personID)
    },
    profileCompany () {
      return this.Profile && this.Profile.Company
    },
    profileCompanyNames () {
      return this.profileCompany && this.profileCompany.CompanyNames
    },
    profileFirstCompanyNameModel () {
      return (this.profileCompanyNames && this.profileCompanyNames[0]) || null
    },
    profileAllCompanyNames () {
      return (this.profileCompanyNames || []).map(f => f.name).join('/')
    },
    companyNameItems () {
      return this.companySearchSkip ? [] : (this.ViewCompanyNameAutocompletes || [])
    },
    companySearchSkip () {
      return this.companySearchLength < this.searchMin
    },
    companySearchLength () {
      return (this.companySearch && this.companySearch.length) || 0
    },
    companySearchVariables () {
      return {
        value: this.companySearch,
        ignoreCase: true
      }
    },
    isLoading () {
      return this.$apollo.loading
    },
    changed () {
      return this.UserProfile && this.Profile && JSON.stringify(this.UserProfile) !== JSON.stringify(this.Profile)
    },
    userProfileID () {
      return this.authArrived && this.UserProfile && this.UserProfile.id
    },
    imageWidthClass () {
      return ' fid-avatar-width'
    },
    displayName () {
      return this.ProviderAuth && this.ProviderAuth.displayName
    },
    userID () {
      return this.ProviderAuth && this.ProviderAuth.userID
    },
    authArrived () {
      return this.ProviderAuth && this.ProviderAuth.emailVerified && this.ProviderAuth.email && this.ProviderAuth.token
    },
    vimeoID () {
      return this.userID && this.UserProfile && this.UserProfile.vimeoID
    },
    vimeoReconnect () {
      return this.Controls && this.Controls.vimeoReconnect
    },
    vimeoConnected () {
      return this.vimeoID && !this.vimeoReconnect
    },
    loginEmail () {
      return this.userID && this.ProviderAuth.emailVerified && this.ProviderAuth.email
    },
    icon () {
      return 'person'
    },
    image () {
      return this.ProviderAuth && this.ProviderAuth.photoUrl
    },
    personItem () {
      return this.itemMake && this.itemMake.item
    },
    itemMake () {
      // make the person query look like a reason from the summary page
      let item = SearchUtils.makeSearcherFromPerson(this.PersonPage)
      if (item) {
        return {
          item,
          big: true
        }
      }
      return null
    }
  },
  data () {
    return {
      updateProfile: false,
      VimeoUserInfo: null,
      Controls: null,
      rowTypes: ['person', 'award', 'film', 'company'],
      enableCompanySearch: false,
      companySearch: null,
      companySearchModel: null,
      searchMin: 1,
      rowType: 'person',
      valid: true,
      ProviderAuth: {},
      Profile: {},
      UserProfile: {},
      UserContacts: null,
      PersonPage: null,
      ViewCompanyNameAutocompletes: null,
      VimeoOauthEndpoint: null,
      checkFid: 'checking identity..',
      checkOut: 'loading..',
      disconnecting: false,
      connecting: false
    }
  },
  methods: {
    flipShowVimeo () {
      return mergeControls({
        showVimeo: !this.showVimeo
      })
    },
    flipShowPersona () {
     return mergeControls({
        showPersona: !this.showPersona
      })
    },
    refetchUserProfile () {
      return this.$apollo.queries.UserProfile.refetch()
    },
    refetchAfterAuth () {
      ifvisible.off('focus')
      return this.refetchUserProfile()
    },
    disconnectVimeo () {
      this.disconnecting = true
      mergeControls({
        vimeoUserSearchText: '',
        vimeoVideoSearchText: '',
        vimeoUserSelectedID: ''
      })
      this.removeVimeoConnection().then(()=>this.refetchUserProfile());
    },
    removeVimeoConnection () {

      return mutate({
        mutation: RemoveVimeoConnection,
        variables: {
          id: this.Profile.id
        }
      })
      .then(()=>this.disconnecting = false)
      .then(()=>{
        this.VimeoUserInfo = null;
      })
    },
    mutateUserProfile ({ input }) {
      return mutate({
        mutation: updateUserProfile,
        variables: {
          id: this.Profile.id,
          input
        }
      }).then(() => {
        showToaster({ header: 'success', type: 'success', message: 'profile updated' })
      }).catch(error => {
        showToaster({ header: 'update error', type: 'error', message: 'failed to commit changes', error })
      })
    },
    vimeoOauthRedirect () { 
      // first step is to get a link to the vimeo auth server
      this.connecting = true
      return this.$apollo.query({
        query: VimeoOauthEndpoint,
        fetchPolicy: 'no-cache',
        variables: {
          id: this.userProfileID
        }
      }).then(result => {
        // now we can go there
        const that = this
        const link = result.data && result.data.VimeoOauthEndpoint && result.data.VimeoOauthEndpoint.url
        if (link) {
          // reconnect is watching for errors (eg access expiring) and will provoke a reconnect
          return mergeControls({
            vimeoReconnect: false
          }).then(() => {
            // set up refresh for when we come back
            // because the oauth screen kills itself when done, this will become visible again
            // go off to the auth screen
            window.open(link, '_blank')
            // wait a little then check for becoming visibile again
            setTimeout(()=> {

              ifvisible.on('focus', () => {
                // wait a bit then refetch the user profile which should be all done by now
                // TODO may need to do a few attempts
                setTimeout(() => that.refetchAfterAuth().then(()=>{
                  this.connecting = false;
                }), 200)
              })

            }, 500)


          })
        } else {
          this.connecting = false;
          throw new Error('no link returned')
        }
      }).catch(error => {
        // so there was an error - set up so that  a reconnect is asked for
        mergeControls({
          vimeoReconnect: true
        })
        showToaster({ header: 'auth failure', type: 'error', message: 'failed to get auth link', error })
        this.connecting = false;
      })

    },
    getIcon (itemType) {
      return getIcon(itemType)
    },
    getIconColor (itemType) {
      return getIconColor(itemType)
    },
    deleteCompany () {
      this.Profile.Company = null
      this.companySearchModel = null
      this.Profile.companyID = null
      this.companySearch = ''
      this.enableCompanySearch = false
    },
    companySearchChanged () {
      this.Profile.companyID = (this.companySearchModel && this.companySearchModel.companyID) || this.Profile.companyID
      this.enableCompanySearch = false
      this.Profile.Company = this.Profile.Company || {}
      this.Profile.Company.id = this.Profile.companyID
      this.Profile.Company.CompanyNames = [this.companySearchModel]
    },
    save () {
      if (this.$refs.userprofileupdate.validate()) {
        // write updated values
        // only primitive fields are required for updating
        const fieldList = [
          'companyID',
          'id',
          'personalAssistantInformation',
          'contactEmail',
          'personID',
          'contactEmailPrivate'
        ]
        const input = Object.keys(this.UserProfile)
          .filter(k => fieldList.indexOf(k) !== -1 && this.UserProfile[k] !== this.Profile[k])
          .reduce((p, c) => {
            p[c] = this.Profile[c]
            return p
          }, {})
        this.mutateUserProfile({ input })
      }
    },
    cancel () {
      // TODO get out of here
    },
    getEmailRules () {
      return [
        v => this.isLoading || !!v || 'E-mail is required',
        v => this.isLoading || /.+@.+/.test(v) || 'E-mail must be valid'
      ]
    },

    // will get called when there's a change in the apollo data
    registerPersonPageResult (data) {
      this.PersonPage = data && data.PersonPage
    },
    registerResult (data) {
      this.UserProfile = data && data.UserProfile
      return this.resetProfile()
    },
    registerUserContactsResult (data) {
      // nothing special to do here
      this.UserContacts = data && data.UserContacts
    },
    // copy profile to working area and set intial states
    resetProfile () {
      this.Profile = this.UserProfile ? JSON.parse(JSON.stringify(this.UserProfile)) : null
      this.enableCompanySearch = false
      this.companySearchModel = this.profileFirstCompanyNameModel
      this.companySearch = (this.companySearchModel && this.companySearchModel.name) || ''
      return this.Profile
    },
    unCamel (text) {
      return SearchUtils.unCamel({ text, capAll: true })
    },
    getMaxLengthRule (maxLength) {
      return v => !v || v.length <= maxLength || `Max of ${maxLength} chars allowed`
    }
  },
  apollo: {
    Controls: {
      query: Controls
    },
    ProviderAuth: {
      query: ProviderAuth
    },
    ViewCompanyNameAutocompletes: {
      query: ViewCompanyNameAutocompletes,
      debounce: 220,
      throttle: 200,
      skip () {
        return this.companySearchSkip
      },
      variables () {
        return this.companySearchVariables
      }
    },
    PersonPage: {
      skip () {
        return !this.profilePersonID
      },
      query: PersonPage,
      variables () {
        return {
          id: this.profilePersonID
        }
      },
      result (result) {
        this.registerPersonPageResult(result && result.data)
      }
    },
    UserProfile: {
      query: UserProfile,
      skip () {
        // don't want to do this if not ready
        return !this.userID
      },
      debounce: 220,
      fetchPolicy: 'no-cache',
      variables () {
        return {
          id: this.userID
        }
      },
      result (result) {
        // make a copy of the data returned from a profile query
        this.registerResult(result && result.data)
      }
    },
    UserContacts: {
      query: UserContacts,
      skip () {
        // don't want to do this if not ready or if we already have a person profile
        return (!this.loginEmail || !this.Profile) || this.personProfileID
      },
      variables () {
        return {
          value: this.loginEmail
        }
      },
      result (result) {
        return this.registerUserContactsResult(result && result.data)
      }
    },
    VimeoUserInfo: {
      query: VimeoUserInfo,
      skip () {
        return (!this.userID || !this.vimeoID)
      },
      fetchPolicy: 'no-cache',
      variables () {
        return {
          id: this.userID
        }
      }
    }
  }
}
</script>